import { heroStats, heroTags } from "@/mocks/site";

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[560px] md:min-h-[720px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20atmosphere%20inspired%20by%20Korean%20television%20drama%2C%20deep%20crimson%20and%20warm%20gold%20light%20streaks%20across%20a%20dark%20moody%20backdrop%20with%20soft%20bokeh%20city%20glow%2C%20dramatic%20film-like%20lighting%2C%20painterly%20artistic%20illustration%2C%20elegant%20and%20atmospheric%2C%20no%20text&width=1920&height=1080&seq=kd-hero-bg-01&orientation=landscape"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80" aria-hidden="true" />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/60 to-transparent" aria-hidden="true" />

      <div className="relative z-10 w-full px-4 md:px-8 pt-28 pb-16 md:pt-36 md:pb-24">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/25 text-background-50 text-xs md:text-sm font-label">
            <i className="ri-live-line text-primary-300" aria-hidden="true" />
            热播 · 更新 · 高分 · 全集 一站看全
          </span>

          <h1 className="mt-5 text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight">
            韩剧TV
            <span className="block mt-2 text-xl md:text-3xl lg:text-4xl font-semibold text-background-50/90">
              正在热播、最新更新与高分韩剧，一次看明白
            </span>
          </h1>

          <p className="mt-5 md:mt-6 text-sm md:text-lg text-background-50/80 leading-relaxed max-w-2xl">
            本站围绕热门韩剧资源需求，系统整理了正在热播的韩剧、最新韩剧更新、高分韩剧推荐与全集资源。
            另有独播剧与人气剧榜单两条线索，方便你从档期、口碑、题材等不同方向对照挑选。
          </p>

          <div className="mt-6 flex flex-wrap gap-2">
            {heroTags.map((tag) => (
              <span
                key={tag}
                className="px-3 py-1.5 rounded-full text-xs md:text-sm font-label text-background-50/90 bg-background-50/10 border border-background-50/20"
              >
                {tag}
              </span>
            ))}
          </div>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#airing"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-label font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-fill text-lg" aria-hidden="true" />
              查看正在热播
            </a>
            <a
              href="#ranking"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 border border-background-50/30 text-background-50 font-label font-medium hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-bar-chart-2-line text-lg" aria-hidden="true" />
              查看人气榜单
            </a>
          </div>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5 max-w-3xl">
          {heroStats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg px-4 py-4 bg-background-50/10 border border-background-50/20 backdrop-blur-sm"
            >
              <p className="font-heading font-bold text-2xl md:text-3xl text-accent-300">
                {stat.value}
                <span className="ml-1 text-sm font-label font-normal text-background-50/70">
                  {stat.unit}
                </span>
              </p>
              <p className="mt-1 text-xs md:text-sm font-label text-background-50/70">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}